import '@babel/polyfill';
import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css';
import './index.less';
import App from './app';
import InitRun from '../../common/initial';
import { initGdp } from '../../utils/gio-report'

initGdp();

InitRun();

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
